var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4017_10934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 13.9022C10.0729 13.9022 8.09802 11.9273 8.09802 9.49994C8.09802 7.07255 10.0729 5.09766 12.5003 5.09766C14.9277 5.09766 16.9026 7.07255 16.9026 9.49994C16.9026 11.9273 14.9277 13.9022 12.5003 13.9022ZM12.5003 6.95074C11.0951 6.95074 9.95157 8.09427 9.95157 9.49948C9.95157 10.9047 11.0951 12.0482 12.5003 12.0482C13.9055 12.0482 15.049 10.9047 15.049 9.49948C15.049 8.09427 13.9055 6.95074 12.5003 6.95074Z",
    fill: "#B0A07F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 23.7135L11.9176 23.243C11.8277 23.1702 9.6861 21.4316 7.51437 18.9384C4.51868 15.499 3 12.4121 3 9.76284V9.50023C3 4.26149 7.26149 0 12.5002 0C17.739 0 22.0005 4.26149 22.0005 9.50023V9.76284C22.0005 12.4121 20.4818 15.4995 17.4861 18.9384C15.3144 21.4316 13.1732 23.1702 13.0829 23.243L12.5002 23.7135ZM12.5002 1.85355C8.28413 1.85355 4.85401 5.28367 4.85401 9.49977V9.76238C4.85401 14.2392 10.6221 19.6586 12.5002 21.3042C14.3779 19.6591 20.1465 14.2392 20.1465 9.76238V9.49977C20.1465 5.28367 16.7163 1.85355 12.5002 1.85355Z",
    fill: "#B0A07F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4017_10934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 23.7135,
    fill: "white",
    transform: "translate(3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMap);
export default __webpack_public_path__ + "static/media/icon-map.5403ebf2da5c92f88344c0a45816caaf.svg";
export { ForwardRef as ReactComponent };